import { RoleAccessRenderer } from '@wizeoo/akm-common-lib';
import { CustomTooltip } from '@wizeoo/akm-common-lib';
import { RoleOrProfileRenderer } from '@wizeoo/akm-common-lib';
import { FeaturePermission } from '@wizeoo/akm-common-lib';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { BATCH_KIND } from '@wizeoo/akm-common-lib';
import { WIZ_COMMAND_STATE, WIZ_EVENT_TYPE,  
  CONFIRMATION_MODE, CONFIRMATION_RESULT, FILTER_TYPE } from '@wizeoo/akm-core-lib';
import {
  ConfirmationResultObj,
  FilterComponent,
  FilterObj,
  WizButton,
  WizCheckbox,
  WizDatasource,
  WizFocusManager,
  WizGroupCommand,
  WizIcon,
  WizPopUp,
  WizRoot,
  WizTextInput,
  WizTranslationInput,
  WizValidationContainerDirective,
  WizValidationError,
  WizValidationErrors,
  WizValidatorFn,
  WizVgroup,
  WizTextarea,
  BATCH_FILE_FORMAT,
  WizEventManager, WizEvent
} from '@wizeoo/akm-component-lib';
import { ColDef, CellClickedEvent } from 'ag-grid-community';
import { MultiDisplay, MultiDisplayConfig } from '@wizeoo/akm-common-lib';
import { PermissionAccess } from '@wizeoo/akm-common-lib';
import { AgLabelValidityRenderer } from '@wizeoo/akm-common-lib';
import { RoleCmd } from '@wizeoo/akm-common-lib';
import { BaseView } from '@wizeoo/akm-common-lib';
import { ProfileCmd } from '@wizeoo/akm-common-lib';
import { PermissionVisibility, StaticFeatureEnum } from '@wizeoo/akm-common-lib';
import { AlkEvent } from '@wizeoo/akm-common-lib';
import { UserContextService } from '@wizeoo/akm-common-lib';
import { ALK_EVENT_TYPE } from '@wizeoo/akm-common-lib';
import { Model } from './../../model/model';
import { ViewData } from '@wizeoo/akm-common-lib';
import { ProfileVO } from '@wizeoo/akm-common-lib';

/**
 * Vue d'administation des profils utilisateurs
 * Author : sva
 */
@Component({
  selector: 'profile-view',
  templateUrl: './profile.view.html',
})
export class ProfileView extends BaseView {
  /** Tableau de profiles */
  // @ViewChild('gridProfiles', { read: WizGridComponent, static: false }) gridProfiles: WizGridComponent;
  @ViewChild('multiDisp', { read: MultiDisplay, static: false }) multiDisp: MultiDisplay<ProfileVO>;
  /** Le groupe contenant le grid */
  @ViewChild('vgGrid', { read: ElementRef, static: false }) vgGridProfiles: ElementRef;
  /** Button d'ajout de profil */
  @ViewChild('btnCreate', { read: WizIcon, static: false }) btnCreate: WizIcon;
  /** Bouton d'export */
  @ViewChild('btnExport', { read: WizIcon, static: false }) btnExport: WizIcon;
  /** Bouton d'import */
  @ViewChild('btnImport', { read: WizIcon, static: false }) btnImport: WizIcon;

  /** Text input de saisie du code */
  @ViewChild('tiCode', { read: WizTextInput, static: false }) tiCode: WizTextInput;
  /** Composant de saisie du libellé traductible */
  @ViewChild('tiLabelTrs', { read: WizTranslationInput, static: false }) tiLabelTrs: WizTranslationInput;
  /** référence de la checkbox de dépreciation */
  @ViewChild('chbDeprecated', { read: WizCheckbox }) private chbDeprecated: WizCheckbox;
  /** Zone de detail */
  @ViewChild('vgDetailZone', { read: WizVgroup }) vgDetailZone: WizVgroup;
  
  /** saisie des filtres sur le profil */
  @ViewChild('taUserFilters', { read: WizTextarea, static: false }) taUserFilters: WizTextarea;
  
  /** Zone de validation des champs de saisie */
  @ViewChild(WizValidationContainerDirective, { read: WizValidationContainerDirective, static: false })
  private vgEditionContainer: WizValidationContainerDirective;

  /** Bouton de sauvegarde */
  @ViewChild('btnSave', { read: WizButton, static: false }) btnSave: WizButton;
  /** Bouton d'annulation de saisie */
  @ViewChild('btnCancel', { read: WizButton, static: false }) btnCancel: WizButton;
  /** Bouton de suppression du profil */
  @ViewChild('btnRemove', { read: WizIcon, static: false }) btnRemove: WizIcon;

  // fitres
  /** le composant de filtre des rôles disponible  */
  @ViewChild('availableRolesFilter', { read: FilterComponent, static: false }) availableRolesFilter: FilterComponent;

  constructor(elementRef: ElementRef) {
    super(elementRef);
  }

  private get _context(): UserContextService {
    return Model.getInstance().userContextService;
  }


  /** Data source de la liste de profil */
  public profileDS: WizDatasource<ProfileVO> = new WizDatasource<ProfileVO>([])
    .setSortFields([{ property: 'code', way: 'asc' }])
    .build();

  // colonne du grid des roles disponibles
  public availableRolesColumns: ColDef[] = [
    { headerName: '$.roles.type.$', width: 80, field: 'trsKind' },
    { headerName: '$.common.code.$', width: 100, field: 'trsCode', resizable: true },
    { headerName: '$.roles.feature.$', flex: 1, minWidth: 250, maxWidth: 600, field: 'trsLabel', tooltipField: 'trsLabel', tooltipComponent: 'customTooltip', resizable: true },
    { headerName: '$.role.kind.all.$', width: 80, field: 'doAll', cellRenderer: (params) => this.roleCrudRenderer('doAll', params.data), cellClass: 'cbox-cell', type: 'boolean' },
    { headerName: '$.role.kind.c.$', width: 80, field: 'doCreate', cellRenderer: (params) => this.roleCrudRenderer('doCreate', params.data), cellClass: 'cbox-cell', type: 'boolean' },
    { headerName: '$.role.kind.r.$', width: 80, field: 'doRead', cellRenderer: (params) => this.roleCrudRenderer('doRead', params.data), cellClass: 'cbox-cell', type: 'boolean' },
    { headerName: '$.role.kind.u.$', width: 80, field: 'doUpdate', cellRenderer: (params) => this.roleCrudRenderer('doUpdate', params.data), cellClass: 'cbox-cell', type: 'boolean' },
    { headerName: '$.role.kind.d.$', width: 80, field: 'doDelete', cellRenderer: (params) => this.roleCrudRenderer('doDelete', params.data), cellClass: 'cbox-cell', type: 'boolean' }
  ];

  /** renderer de libellé des rôles disponible */
  public availableRolesRenderer = { labelRenderer: AgLabelValidityRenderer, roleOrProfileRenderer: RoleOrProfileRenderer, customTooltip: CustomTooltip, accessRenderer: RoleAccessRenderer };

  public rolesByFeature: WizDatasource<FeaturePermission> = new WizDatasource([])
    .setFilter(this.featureFilterFunc.bind(this))
    .setSortFields([{ property: 'code', way: 'asc' }])
    .build();

  /**
   * Méthode de filtre des roles disponibles
   * @param item Element de la liste de role testé
   * @returns boolean, true si l'element correspond au filtre, false sinon
   */
  private featureFilterFunc(item: FeaturePermission): boolean {
    return !!this.availableRolesFilter ? this.availableRolesFilter.checkVisible(item) : false;
  }

  /** affichage ou non du panneau detail */
  public get showDetail(): boolean {
    // console.log('clone', this.clone);
    return !!this.clone && Model.getInstance().permissionEngine.hasAnyPermission({
      feature: StaticFeatureEnum.VISION_PROFILE,
      accesses: [PermissionAccess.CREATE, PermissionAccess.UPDATE],
      visibility: PermissionVisibility.DISABLED
    });
  }

  /** Profil dans la zone de détail */
  private _currentProfile: ProfileVO = undefined;

  public get currentProfile(): ProfileVO {
    return this._currentProfile;
  }

  public set currentProfile(profile: ProfileVO) {
    this._currentProfile = profile;
    // Sauvegarde dans l'engine pour sélection par défaut ultérieure
    Model.getInstance().currentEditedProfile = profile;
    // clone le currentProfile pour pouvoir supprimer les modifications en cas d'annulation
    this.clone = this._currentProfile ? Model.getInstance().profileEngine.clone(profile) : null;
    this.btnRemove.wizDisabled =
      !this.showDetail || !Model.getInstance().permissionEngine.canDelete(StaticFeatureEnum.VISION_PROFILE);
  }

  /**
   * clone du currentProfile
   * permet de ne pas altérer l'instance
   */
  private clone: ProfileVO = null;


  /* #############################################################
                        CYCLE DE VIE WizView
     ############################################################# */

  /**
   * Pretraitement: chargement des données nécessaires à la vue
   * @return WizGroupCommand
   */
  public wizBeforeInit(): WizGroupCommand {
    super.wizBeforeInit();
    const calls = [];

    // Chargement des roles si vide
    if (!Model.getInstance().rolesMap.has(Model.getInstance().businessUnitCode)) {
      // Chargement des roles
      calls.push(new RoleCmd(Model.getInstance()).find());
    }
    // Chargement des profiles dans tous les cas
    calls.push(new ProfileCmd(Model.getInstance()).find());

    return new WizGroupCommand().configure(calls);
  }

  /**
   * Synchronisation des données
   */
  public wizSynchronizeData(): void {
    super.wizSynchronizeData();

    super.managePermissions([
      {
        feature: StaticFeatureEnum.VISION_PROFILE,
        permissions: [
          {
            component: this.btnCreate,
            accesses: [PermissionAccess.CREATE],
            visibility: PermissionVisibility.DISABLED,
          },
          // {
          //   component: this.vgDetailZone,
          //   accesses: [PermissionAccess.READ, PermissionAccess.CREATE, PermissionAccess.UPDATE],
          //   visibility: PermissionVisibility.DISABLED,
          // },
          {
            component: this.btnRemove,
            accesses: [PermissionAccess.DELETE],
            visibility: PermissionVisibility.DISABLED,
          },
          {
            component: this.btnExport,
            accesses: [PermissionAccess.BATCH],
            visibility: PermissionVisibility.DISABLED,
          },
          {
            component: this.btnImport,
            accesses: [PermissionAccess.BATCH],
            visibility: PermissionVisibility.DISABLED,
          },
        ],
      },
    ]);

    this.currentProfile = Model.getInstance().profileEngine.getCurrentInstance(Model.getInstance().currentEditedProfile);

    let profs: Map<string, ProfileVO> = new Map();
    if (Model.getInstance().profileMap?.get(Model.getInstance().businessUnitCode)?.has(Model.getInstance().visionCode)) {
      profs = Model.getInstance().profileMap.get(Model.getInstance().businessUnitCode).get(Model.getInstance().visionCode);
    }

    this.profileDS.setSource([...profs.values()]);
    this.profileDS.setSelectedItems([this.currentProfile]);

    // Ajout de restriction pour le code
    this.tiCode.wizPattern = ViewData.CODE_REGEXP;
    this.tiCode.wizPatternErrorMessage = '$.common.code.error.alphanumeric.$';

    this.buildFilter();
    this.buildAvailableRolesFilters();

    this.feed();
  }

  /**
   * Mise en place des écouteurs
   */
  public wizAddListener(): void {
    super.wizAddListener();
    // écouteur global change pour modelUpdate
    WizEventManager.addListener(this, this.vgDetailZone, WIZ_EVENT_TYPE.MODEL_UPDATE, this.updateModel);
    // écoute des filtres
    WizEventManager.addListener(this, this.availableRolesFilter, WIZ_EVENT_TYPE.FILTER, () =>
      this.rolesByFeature.refresh()
    );

    // Save
    WizEventManager.addListener(this, this.btnSave, WIZ_EVENT_TYPE.CLICK, this.save);
    // Cancel
    WizEventManager.addListener(this, this.btnCancel, WIZ_EVENT_TYPE.CLICK, this.askForCancel);
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.BATCH_IMPORT_RETURN, this.backFromImport);
  }


  /**
   * Suppression des écouteurs
   */
  public wizRemoveListener(): void {
    super.wizRemoveListener();
    WizEventManager.removeListener(this, this.vgDetailZone, WIZ_EVENT_TYPE.MODEL_UPDATE);
    WizEventManager.removeListener(this, this.availableRolesFilter, WIZ_EVENT_TYPE.FILTER);
    WizEventManager.removeListener(this, this.btnSave, WIZ_EVENT_TYPE.CLICK);
    WizEventManager.removeListener(this, this.btnCancel, WIZ_EVENT_TYPE.CLICK);
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.BATCH_IMPORT_RETURN);
  }

  /** mémorisation du filtre */
  wizOnDestroy(): void {
    super.wizOnDestroy();
    // this._context.saveLocalFilter(this.mainFilter);
    // this._context.saveLocalFilter(this.availableRolesFilter, 'AVAILABLE_FILTER');
  }

  /* ##############################################################################
                    Panneau gauche : Liste, sélection, filtres
     ############################################################################## */

  /**
   * configuration de l'affichage en multi liste
   */
  public multiDisplayConfig: MultiDisplayConfig<ProfileVO> = {
    model: Model.getInstance(),
    datasource: this.profileDS,
    defaultMode: 'grid',
    onSelectionChanging: this.onWizEventSelectionChange.bind(this),
    grid: {
      enabled: true,
      columns: [
        { headerName: '$.common.code.$', field: 'code', width: 80, sortable: true, tooltipField: 'code' },
        {
          headerName: '$.common.label.$',
          field: 'trsLabel',
          flex: 1,
          sortable: true,
          cellRenderer: 'labelValidityRenderer',
        },
      ],
      renderers: {
        labelValidityRenderer: AgLabelValidityRenderer,
      },
    },
    filter: {
      enabled: true,
      initFilter: this.initFilter.bind(this),
    },
  };

  private mainFilter: FilterComponent;

  private initFilter(pFilter: FilterComponent): FilterComponent {
    this.mainFilter = pFilter;
    return this.mainFilter;
  }

  /**
   * construction de la zone de filtre des profils
   * @param event : Evenement de changement dans le text input de filtre
   */
  private buildFilter(event: WizEvent = null): void {
    // datasource de la combo de langue
    // const cbSource: WizDatasource<RoleVO> = this.roleDS.clone();

    // liste de filtres complémentaires
    const filter = [];

    filter.push(FilterObj.create('deprecated', '$.common.filter.show.deprecated.$', FILTER_TYPE.BOOLEAN, false, 2));
    filter.push(FilterObj.create('deleted', '$.common.filter.show.deleted.$', FILTER_TYPE.BOOLEAN, false, 3));

    this.mainFilter.configure(['code', 'trsLabel'], null, filter);
    // le contextEngine prend le relais pour alimenter les filtres par défaut
    this._context.feedFilterContext(this.mainFilter);
  }

  /**
   * construction de la zone de filtre des roles
   * @param event : Evenement de changement dans le text input de filtre
   */
  private buildAvailableRolesFilters(event: WizEvent = null): void {
    this.availableRolesFilter.configure(['trsCode', 'trsKind', 'trsLabel'], null, null);
    // le contextEngine prend le relais pour alimenter les filtres par défaut
    this._context.feedFilterContext(this.availableRolesFilter, 'AVAILABLE_FILTER');

    this.rolesByFeature.refresh();
  }

  /**
   * Callback de selection dans le grid
   * @param pEvent WizEvent
   */
  private onWizEventSelectionChange(pEvent: WizEvent): void {
    // empêche le changement de selection quand il y a une modification de model en cours
    if (ViewData.wizUpdateModel) {
      // pas de désélection d'un item
      if (this.profileDS.isSelected(pEvent.value)) {
        pEvent.preventDefault();
        return;
      }
      // on stop le fonctionnement par défaut pour afficher la pop, on sélectionnera l'item seulement si le user confirme
      pEvent.preventDefault();
      const target: ProfileVO = pEvent.value as ProfileVO;

      WizPopUp.confirm(
        '$.common.pending.update.title.$',
        '$.common.pending.update.detail.$',
        this.popupConfirmationUpdatedModelCallback.bind(this),
        CONFIRMATION_MODE.CONFIRM_CANCEL,
        target,
        null,
        this.clone
      ).show();
    } else {
      this.selectProfile(pEvent.value);
    }
  }

  /**
   * Confirmation d'abandon de modifs
   * Callback de la  WizPopupConfirmation déclenché quand on navigue dans la liste
   * alors qu'il y a une modification de model en cours
   * @param result Confirmation
   */
  private popupConfirmationUpdatedModelCallback(result: ConfirmationResultObj): void {
    if (result.result === CONFIRMATION_RESULT.CONFIRM) {
      const profile: ProfileVO = result.data;
      // Sélection du nouvel élément
      this.selectProfile(profile as ProfileVO);
      this.profileDS.toggle(this.currentProfile);
    }
  }

  /**
   * Selection d'un profil
   * @param pProfile: Le profile à sélectionner
   */
  public selectProfile(pProfile: ProfileVO) {
    this.currentProfile = this.profileDS.isSelected(pProfile) ? null : pProfile;

    // Rinçage des filtres à la sélection d'un profil
    this.availableRolesFilter.resetFilter();

    // Alimentation de la zone de saisie
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, false));
    this.feed();
  }


  public doAct(action: string): void {
    switch (action) {
      case 'export':
        Model.getInstance().batchEngine.export(BATCH_KIND.PROFILE, BATCH_FILE_FORMAT.JSON, Model.getInstance().visionCode);
        break;
      case 'import':
        Model.getInstance().batchEngine.import(BATCH_KIND.PROFILE);
        break;
      case 'delete':
        this.doAskForRemove(this.currentProfile);
        break;
      case 'create': // demande de create
        this.askForAddProfile();
        break;
    }
  }

  /** callback sur retour d'import : recharger les Freedatas */
  private backFromImport(e: AlkEvent): void {
    if (e && e.data === BATCH_KIND.PROFILE) {
      new ProfileCmd(Model.getInstance()).find().configure(this.backFromReload.bind(this)).execute();
    }
  }

  private backFromReload(e: any): void {
    this.wizSynchronizeData();
  }

  /**
   * Demande de création de profil
   */
  private askForAddProfile(): void {
    if (ViewData.wizUpdateModel) {
      WizPopUp.confirm(
        '$.common.pending.update.title.$',
        '$.common.pending.update.detail.$',
        this.addProfile.bind(this),
        CONFIRMATION_MODE.CONFIRM_CANCEL,
        this.currentProfile,
        null,
        this.clone
      ).show();
    } else {
      this.addProfile(ConfirmationResultObj.build(CONFIRMATION_RESULT.CONFIRM, this.currentProfile));
    }
  }

  /**
   * Création d'un profil
   */
  private addProfile(result: ConfirmationResultObj): void {
    if (result.result === CONFIRMATION_RESULT.CONFIRM) {
      // Creer un nouvel object
      this.currentProfile = Model.getInstance().profileEngine.createObjectProfile();
      this.profileDS.select(null);
      this.feed();
    }
  }

  /* #########################################
                    Detail
     ######################################### */

  /**
   * Initialisation des valeurs des champs dans le conteneur d'edition en fonction du currentCountry
   */
  public feed(): void {
    if (this.currentProfile) {
      this.tiCode.wizValue = this.clone.code;
      this.tiLabelTrs.translationData = Model.getInstance().localeEngine.buildTranslationData(this.clone.labelVO);

      this.taUserFilters.wizValue = this.clone.tags ? JSON.stringify(this.clone.tags) : null;

      // synchronisation de la checkbox de depréciation
      this.chbDeprecated.wizChecked = this.clone.deprecated;

      const featuresMap: Map<string, FeaturePermission> = Model.getInstance().userAppEngine.generatePermission(); // map cible par code Feature

      this.rolesByFeature.setSource(Array.from(featuresMap.values()));
      this.rolesByFeature.select([]);
    }

    this.manageComponents();

    // set focus
    if (this.currentProfile && this.currentProfile.exist) {
      WizFocusManager.getInstance().wizSetFocus(this.tiLabelTrs);
    } else {
      WizFocusManager.getInstance().wizSetFocus(this.tiCode);
    }
  }

  /** methode qui change la visibilité des composants */
  private manageComponents(): void {
    if (this.clone) {
      this.tiCode.wizDisabled =
        this.clone.exist ||
        !Model.getInstance().permissionEngine.hasAnyPermission({
          feature: StaticFeatureEnum.VISION_PROFILE,
          accesses: [PermissionAccess.CREATE, PermissionAccess.UPDATE],
          visibility: PermissionVisibility.DISABLED,
        });
      this.btnRemove.wizDisabled =
        !this.clone.exist || !Model.getInstance().permissionEngine.canDelete(StaticFeatureEnum.VISION_PROFILE);
      // on desactive la checkbox de dépréciation lors d'une création
      this.chbDeprecated.wizDisabled =
        !this.clone.exist ||
        !Model.getInstance().permissionEngine.hasAnyPermission({
          feature: StaticFeatureEnum.VISION_PROFILE,
          accesses: [PermissionAccess.CREATE, PermissionAccess.UPDATE],
          visibility: PermissionVisibility.DISABLED,
        });
    }

    // Affichage des button en fonction du model update en prennant en compte si il y a eu modification ou non
    if (ViewData.wizUpdateModel /* && !isEqual(this._currentProfile.source, this.clone.source) */) {
      this.btnSave.wizDisabled = false;
      this.btnCancel.wizDisabled = false;
    } else {
      this.btnSave.wizDisabled = true;
      this.btnCancel.wizDisabled = true;
    }
  }

  /* ###############################
                  Saisie
     ############################### */

  /**
   * Modification du model dans la zone de saisie
   * @param e Evenement model change
   */
  private updateModel(e: WizEvent): void {
    switch (e.component) {
      case this.tiCode:
        this.clone.code = this.tiCode.wizValue?.toUpperCase();
        WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, true));
        break;
      case this.tiLabelTrs:
        this.clone.labelVO.updateTranslationEntry(e.value);
        WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, true));
        break;
      case this.chbDeprecated:
        this.clone.deprecated = this.chbDeprecated.wizChecked;
        WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, true));
        break;
        case this.taUserFilters:
          try {
            this.clone.tags = JSON.parse(this.taUserFilters.wizValue);
          } catch(e: any) {
            this.clone.tags = null;
          }

          // this.clone.tags = this.taUserFilters.wizValue;
          WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, true));
          break;

    }
    this.manageComponents();
  }

  /* #####################################
        VALIDATION DE SAISIE
    ##################################### */

  /**
   * Validateur d'unicité du code
   */
  public uniqueCodeValidator(): WizValidatorFn {
    return (): WizValidationErrors | null => {
      // Pas de gestion d'erreur si le currentRole est null
      if (this.clone === null || this.clone === undefined) {
        return null;
      }

      if (
        this.tiCode.wizValue !== null &&
        this.tiCode.wizValue &&
        this.tiCode.wizValue.length > 0 &&
        !this.clone.exist
      ) {
        // Recherche d'un autre role avec le même code
        // TODO, unicité sur BU !!
        const otherRole = Model.getInstance().profileMap?.get(Model.getInstance().businessUnitCode)?.get(Model.getInstance().visionCode)?.get(this.tiCode.wizValue.toUpperCase());

        // Si un role existe deja avec le meme code on affiche le message
        if (otherRole && otherRole !== this.currentProfile) {
          const temp: WizValidationError = {
            wizError: '$.profile.error.code.unique.$',
            wizErrorParams: [],
          };
          return [temp];
        }
      }
      return null;
    };
  }

  /**
   * Demande d'annulation de saisie
   */
  private askForCancel(): void {
    // open confirmation popup
    WizPopUp.confirm(
      '$.common.pending.update.title.$',
      '$.common.pending.update.detail.$',
      this.doCancel.bind(this),
      CONFIRMATION_MODE.YES_NO,
      this.currentProfile,
      null
    ).show();
  }

  /**
   * confirmation de l'annulation de saisie
   */
  private doCancel(result: ConfirmationResultObj): void {
    if (result.result === CONFIRMATION_RESULT.YES) {
      this.reset();
    }
  }

  /**
   * Annulation des modifications
   */
  public reset() {
    WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, false));
    if (this.currentProfile) {
      if (!this.currentProfile.exist) {
        this.addProfile(ConfirmationResultObj.build(CONFIRMATION_RESULT.CONFIRM, this.currentProfile));
      } else {
        this.clone = Model.getInstance().profileEngine.clone(this.currentProfile);
        this.feed();
      }
    }
  }

  /** Sauvegarde */
  public save(): void {
    // Vérification de la saisie
    const errors = this.vgEditionContainer.check(true, true);
    if (errors && errors.length === 0) {
      // si le country est valide on persiste les modifications
      if (Model.getInstance().profileEngine.isValid(this.clone)) {
        Model.getInstance().profileEngine.merge(this.clone, Model.getInstance().currentEditedProfile, this.mergeCallback.bind(this));
      }
    }
  }

  /**
   * Retour de service merge
   * @param  bddPersist: ProfileVO
   * @param status le statut de retour du service
   * @return boolean: vrai si la comande est en succes
   */
  private mergeCallback(bddPersist: ProfileVO, status: string): boolean {
    if (status === WIZ_COMMAND_STATE.SUCCESS) {
      const isCreation: boolean = !this.currentProfile.exist;
      // mise a jour du current profile et du clone
      this.currentProfile = Model.getInstance().profileMap.get(Model.getInstance().businessUnitCode)
        .get(Model.getInstance().visionCode).get(bddPersist.code);

      if (isCreation) {
        // en créa, on ajoute l'item, on le sélectionne et on le rend visible dans la liste
        this.profileDS.addItem(this.currentProfile);
        this.profileDS.toggle(this.currentProfile);
        // this.gridProfiles.ensureIndexIsVisible(this.currentProfile);
      } else {
        this.profileDS.itemUpdated([this.currentProfile]);
      }

      this.feed();
      WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, false));

      return true;
    }

    return false;
  }

  public onPermissionCellClicked({ colDef, data, node, api, column }: CellClickedEvent) {
    if (colDef.type === 'boolean') {
      const perm: FeaturePermission = data;
      // gestion si roles
      const permToCheck: string = colDef.field;
      let roles = [];
      if (permToCheck === 'doAll') {
        const hasAllRoles = perm.roles.filter(r => this.clone.hasRole(r));

        // on avait déjà tous les rôles
        if (hasAllRoles.length === perm.roles.length) {
          hasAllRoles.forEach(r => this.clone.removeRole(r.code));
        } else {
          perm.roles.filter(r => !hasAllRoles.includes(r)).forEach(r => this.clone.addRole(r));
        }

        api.refreshCells({ force: true, rowNodes: [node], suppressFlash: true });
      } else {
        roles = perm.roles.filter(r => !!r[permToCheck] && this.clone.hasRole(r));

        if (roles.length > 0) {
          // on est en status checked
          roles.forEach(r => this.clone.removeRole(r.code));
        } else {
          perm.roles.filter(r => !!r[permToCheck]).forEach(r => this.clone.addRole(r));
        }

        api.refreshCells({ force: true, rowNodes: [node], suppressFlash: true });
      }

      WizEventManager.dispatchEvent(this.elementRef, new AlkEvent(ALK_EVENT_TYPE.UPDATE_MODEL, true));
      this.manageComponents();
    }
  }

  private roleCrudRenderer(permToCheck: string, perm: FeaturePermission): string {
    if (!this.clone) {
      return `<i class="fa-regular fa-square"></i>`;
    }

    if (permToCheck === 'doAll') {
      const hasAllRoles = perm.roles.filter(r => this.clone.hasRole(r));

      if (hasAllRoles.length === perm.roles.length) {
        return `<i class="fa-regular fa-square-check"></i>`;
      } else {
        return `<i class="fa-regular fa-square"></i>`;
      }
    } else {
      const permRoles = perm.roles.filter(r => !!r[permToCheck]);
      if (permRoles.length > 0) {
        if (permRoles.filter(r => this.clone.hasRole(r)).length > 0) {
          return `<i class="fa-regular fa-square-check"></i>`;
        } else {
          return `<i class="fa-regular fa-square"></i>`;
        }
      } else {
        return ``;
      }
    }
  }

  /**
   * Demande de suppression d'un profil
   * @param pProfile : Profil à supprimer
   */
  private doAskForRemove(pProfile: ProfileVO): void {
    if (this.isValidForRemove(pProfile)) {
      WizPopUp.confirm(
        '$.common.delete.title.$',
        '$.common.delete.detail.$',
        this.doRemoveProfile.bind(this),
        CONFIRMATION_MODE.CONFIRM_CANCEL,
        pProfile,
        null
      ).show();
    } else {
      WizPopUp.toast('$.profile.toast.remove.unvalid.$', WizIcon.TOAST_ERROR).show();
    }
  }

  private isValidForRemove(pProfile: ProfileVO): boolean {
    return true;
  }

  /**
   * Suppression de profil
   * @param pCountry Le profil à supprimer
   */
  private doRemoveProfile(result: ConfirmationResultObj): void {
    if (result.result === CONFIRMATION_RESULT.CONFIRM) {
      const pProfile: ProfileVO = result.data;
      if (pProfile) {
        if (pProfile.exist) {
          Model.getInstance().profileEngine.remove(pProfile, this.removeProfileCallback.bind(this));
        } else {
          this.reset();
        }
      }
    }
  }

  /**
   * Callback de suppression de profil
   *  @param cmd WizCommand
   */
  private removeProfileCallback(bddPersist: ProfileVO, status: string): void {
    if (status === WIZ_COMMAND_STATE.SUCCESS) {
      this.profileDS.removeItem(bddPersist);
      // Si suppression du profil dans le panneau detail, reset
      if (bddPersist.code === this.currentProfile.code) {
        this.currentProfile = undefined;
        this.reset();
      }
      // Affiche un toast de succès
      WizPopUp.toast('$.profile.toast.remove.success.$', WizIcon.TOAST_SUCCESS).show();
    }
  }


}
